import api from './api';

export const couponService = {
  /**
   * Validate a coupon code (preview discount without reserving)
   */
  validate: async (code, subtotal, shippingCost) => {
    const response = await api.post('/coupons/validate', {
      code,
      subtotal,
      shippingCost,
    });
    return response.data;
  },

  /**
   * Apply a coupon (creates a reservation)
   */
  apply: async (code, subtotal, shippingCost) => {
    const response = await api.post('/coupons/apply', {
      code,
      subtotal,
      shippingCost,
    });
    return response.data;
  },

  /**
   * Remove an applied coupon (release reservation)
   */
  remove: async (reservationId) => {
    const response = await api.delete(`/coupons/reservations/${reservationId}`);
    return response.data;
  },

  /**
   * Get current active coupon reservation
   */
  getActive: async () => {
    const response = await api.get('/coupons/active');
    return response.data;
  },
};

export default couponService;
